module.exports = __webpack_public_path__ + "static/img/logo_only.dd31e013.png";